
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ActivityTrackerPreferenceRequest,
  ActivityTrackerPreferenceResource,
} from '../models';
import {
    ActivityTrackerPreferenceRequestFromJSON,
    ActivityTrackerPreferenceRequestToJSON,
    ActivityTrackerPreferenceResourceFromJSON,
    ActivityTrackerPreferenceResourceToJSON,
} from '../models';

export interface GetActivityTrackerPreferenceRequest {
    companyId: string;
}

export interface UpdateActivityTrackerPreferenceRequest {
    companyId: string;
    activityTrackerPreferenceRequest: ActivityTrackerPreferenceRequest;
}

/**
 * 
 */
export class ActivityTrackerPreferenceApi extends runtime.BaseAPI {

    /**
          */
    async getActivityTrackerPreferenceRaw(requestParameters: GetActivityTrackerPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityTrackerPreferenceResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getActivityTrackerPreference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ActivityTrackerPreferenceResource>({
            path: `/client-settings/api/{companyId}/activity-tracker-preference`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ActivityTrackerPreferenceResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getActivityTrackerPreference(requestParameters: GetActivityTrackerPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityTrackerPreferenceResource> {
        const response = await this.getActivityTrackerPreferenceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updateActivityTrackerPreferenceRaw(requestParameters: UpdateActivityTrackerPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityTrackerPreferenceResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateActivityTrackerPreference().'
            );
        }

        if (requestParameters['activityTrackerPreferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'activityTrackerPreferenceRequest',
                'Required parameter "activityTrackerPreferenceRequest" was null or undefined when calling updateActivityTrackerPreference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ActivityTrackerPreferenceResource>({
            path: `/client-settings/api/{companyId}/activity-tracker-preference`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivityTrackerPreferenceRequestToJSON(requestParameters['activityTrackerPreferenceRequest']),
        }, initOverrides);

        if (response._data) { response._data=ActivityTrackerPreferenceResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateActivityTrackerPreference(requestParameters: UpdateActivityTrackerPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityTrackerPreferenceResource> {
        const response = await this.updateActivityTrackerPreferenceRaw(requestParameters, initOverrides);
        return response._data;
    }

}
